import axios from "axios";

const BASE_URL = 'http://127.0.0.1:8000/api/';

const SubscripationPlanVeiwController = () => {

  const getPlans = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.get(
        `${BASE_URL}plans/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_PLANS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_PLANS_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  const addDemoRequest = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.post(
        `${BASE_URL}demo/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_REQUEST_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ADD_REQUEST_FAILURE", payload: { error } });
      return Promise.reject(error); // ✅ return error
      
    }
  };
  
   const addContactUsRequest = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.post(
        `${BASE_URL}contact-us/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);

      dispatch({ type: "ADD_CONTACT_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      return Promise.resolve(data); // ✅ return success
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({ type: "ADD_CONTACT_FAILURE", payload: { error } });
      return Promise.reject(error); // ✅ return error
      
    }
  };
  
  
  return {
    getPlans,addDemoRequest, addContactUsRequest
  };
};

export default SubscripationPlanVeiwController;
